import { useEffect, useState } from "react";
import EasyPalletService from "../../../services/resource/easyPalletService";
import {
    formatLocalDate,
    getAnteontem,
    getComecoAno,
    getDataSeteDiasAntesFormatado,
    getHojeFormatado,
    getMesAtual,
    getMesPassado,
    getOntemFormatado,
    ultimoDiaMesPassado
} from "../../../utils/formatDate";

import { intervaloDatasFull } from "../../../utils/options";
import FilialService from "../../../services/resource/filialService";
import { TabelaPorMontador } from "./TabelaPorMontador";
import { ProducaoDiaria } from "./ProducaoDiaria";
import { toast } from "react-toastify";
import { exportDashboardToPDF } from "../../../utils/exportarDashboardEmPDF";
import { ProducaoMensal } from "./ProducaoMensal";
import { DesempenhoPorMontador } from "./DesempenhoPorMontador";
import { ErrosPorMontador } from "./ErrosPorMontador";
import { reduzirNome } from "../../../utils/reduzirNome";
import { ErrosVsAcertos } from "./ErrosVsAcertos";
import { captureElementToImage } from "../../../utils/captureElementToImage";
import { copyElementToClipboard } from "../../../utils/copyElementToClipboard";
import { ChartCard } from "../../../componentes/chart/CardChart";
import { KPICard } from "../../../componentes/chart/KPICard";
import { useAuth } from "../../../context/authContext";
import DropdownButton from "../../../componentes/dropdown/newDropdown";
import { ProducaoHeatmap } from "./ProducaoHeatmap";
import { RankingAtingimentoMeta } from "./RankingAtingimentoMeta";

const C = {
    bg: "#F0F4F8",
    surface: "#FFFFFF",
    surfaceAlt: "#F8FAFC",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    primary: "#0EA5E9",
    primaryDark: "#0284C7",
    secondary: "#6366F1",
    accent: "#10B981",
    danger: "#EF4444",
    warn: "#F59E0B",
    purple: "#8B5CF6",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    c1: "#0EA5E9",
    c2: "#6366F1",
    c3: "#10B981",
    c4: "#F59E0B",
    c5: "#EF4444",
};

const initialValues = {
    "totalCaixas": 41774,
    "totalPaletes": 604,
    "totalErros": 46,
    "mediaPaletesPorColaboradorPorDia": 13.727272727272727,
    "mediaCaixasPorColaboradorPorDia": 949.4090909090909,
    "mediaPaletesPorDia": 151,
    "mediaCaixasPorDia": 10443.5,
    "mediaErrosPorDia": 11.5,
    "mediaTempoColaborador": 138.62477272727273,
    "totalPorDia": [],
    "caixasPorDia": {},
    "paletesPorDia": {},
    "caixasPorMontador": {},
    "paletesPorMontador": {},
    "errosPorMontador": {},
    "produtividadePorMontador": {},
    "totalCaixasPorFilial": {},
    "totalPaletesPorFilial": {},
    "totalErrosPorFilial": {},
    "mediaPaletesPorColaborador": {},
    "mediaPaletesDias": {},
    "produtividade": []
}

export default function ListaTrabalhadaPage() {
    const { user } = useAuth();
    const isRoleComissao = user.perfis.includes("COMISSOES")

    const [dataInicial, setDataInicial] = useState(getMesAtual());
    const [dataFinal, setDataFinal] = useState(getHojeFormatado());
    const [filiais, setFiliais] = useState([]);
    const [filial, setFilial] = useState(isRoleComissao ? user.filialId : 1);
    const [funcionario, setFuncionario] = useState(null);
    const [listaFuncionarios, setRelatorioFuncionarios] = useState({});
    const [relatorio, setRelatorio] = useState(initialValues);
    const [loading, setLoading] = useState(true);
    const [dataSelecionada, setDataSelecionada] = useState(7);
    const [verCaixasPorDia, setVerCaixasPorDia] = useState('chart')
    const service = new EasyPalletService();
    const filialService = new FilialService();

    useEffect(() => {
        filialService.listarAtivas().then(response => {
            setFiliais(response.data)
        })

        document.title = "MyDash | Montagem de Cargas"

    }, []);

    useEffect(() => {
        fetchData();
    }, [filial, funcionario, dataInicial, dataFinal]);

    useEffect(() => {
        service.listaMontadores(filial).then(res => {
            setRelatorioFuncionarios(res.data)
        }).catch(e => console.error(e));

        setFuncionario(null);
    }, [filial])

    const fetchData = () => {
        setLoading(true);
        service.relatorio(dataInicial, dataFinal, filial, funcionario)
            .then(res => {
                setRelatorio(res.data);
            })
            .catch(err => {
                console.error("Erro ao carregar relatório:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const formatarDataPtBr = (data) =>
        new Date(data).toLocaleDateString("pt-BR");

    const buscarDadosEasyPallet = () => {

        const toastId = toast.loading(
            `Buscando informações do EasyPallet no período de ${formatarDataPtBr(dataInicial)} a ${formatarDataPtBr(dataFinal)}...`
        );


        service.listaTrabalhada(dataInicial, dataFinal)
            .then(res => {
                fetchData();

                toast.update(toastId, {
                    render: "Todas as informações sobre EasyPallet foram atualizadas!",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000
                });
            })
            .catch(err => {
                console.error("Erro ao carregar relatório:", err);

                toast.update(toastId, {
                    render: "Erro ao atualizar as informações do EasyPallet.",
                    type: "error",
                    isLoading: false,
                    autoClose: 4000
                });
            });
    };

    const mudarPeriodoDeDatas = (e) => {
        const valor = e.target.value;
        setDataSelecionada(e.target.value);
        if (valor === 7) {
            setDataInicial(getMesAtual());
            setDataFinal(getHojeFormatado());
        } else if (valor == 0) {
            setDataInicial(getHojeFormatado());
            setDataFinal(getHojeFormatado());
        } else if (valor == 1) {
            setDataInicial(getOntemFormatado());
            setDataFinal(getOntemFormatado());
        } else if (valor == 2) {
            setDataInicial(getAnteontem());
            setDataFinal(getAnteontem());
        } else if (valor == 30) {
            setDataInicial(getMesPassado());
            setDataFinal(ultimoDiaMesPassado());
        } else if (valor == 365) {
            setDataInicial(getComecoAno());
            setDataFinal(getHojeFormatado());
        } else if (valor == 700) {
            setDataInicial('2025-01-01');
            setDataFinal('2025-12-31');
        } else {
            setDataInicial(getDataSeteDiasAntesFormatado(valor));
            setDataFinal(getHojeFormatado());
        }
    }

    function formatNum(n) {
        if (n == null) return "0";
        return Number(n).toLocaleString("pt-BR");
    }

    function minutosParaHoras(minutos) {
        const horas = Math.floor(minutos / 60);
        const minutosRestantes = minutos % 60; // já é inteiro
        return `${horas}h ${minutosRestantes?.toFixed(0)}m`;
    }

    const funcionariosOptions = Object.entries(listaFuncionarios).flatMap(
        ([filial, funcionarios]) =>
            funcionarios.map((nome) => ({
                label: `${reduzirNome(nome)}`,
                value: nome,
            }))
    );

    const dropdownItem = {
        width: "100%",
        background: "transparent",
        border: "none",
        padding: "10px 14px",
        textAlign: "left",
        cursor: "pointer",
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "var(--font-sans)",
        display: "flex",
        alignItems: "center",
        gap: 8,
    };

    const selectStyle = {
        background: C.surfaceAlt,
        border: `1.5px solid ${C.border}`,
        color: C.textMid,
        padding: "6.4px 14px",
        borderRadius: 8,
        cursor: "pointer",
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "var(--font-sans)",
    };

    const dateStyle = {
        background: C.surfaceAlt,
        border: `1.5px solid ${C.border}`,
        color: C.textMid,
        padding: "4px 10px",
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "var(--font-sans)",
    };


    return (
        <div className="font-sans min-h-screen" style={{ background: C.bg, color: C.text }}>
            <div className="sticky top-0 z-[100] flex items-center justify-between shadow-xs" style={{
                background: C.surface, borderBottom: `1px solid ${C.border}`,
                padding: "0 24px", height: 58,
            }}>

                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div onClick={() => {
                        const isAdmin = user.perfis.includes('ADMIN');
                        if (isAdmin) buscarDadosEasyPallet();
                    }} className="font-display" style={{
                        cursor: 'default', width: 34, height: 34, background: C.danger, borderRadius: 9,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 13, fontWeight: 800, color: "#fff", letterSpacing: -.5,
                    }}>EP</div>
                    <div>
                        <div className="font-display" style={{ fontSize: 14, fontWeight: 700, color: C.text, lineHeight: 1.2 }}>
                            Montagem de Cargas
                        </div>
                        <div style={{ fontSize: 11, color: C.muted }}>Relatório das montagens de cargas do Easypallet</div>
                    </div>
                </div>

                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>

                    <select
                        value={dataSelecionada}
                        onChange={mudarPeriodoDeDatas}
                        style={selectStyle}
                    >
                        {intervaloDatasFull.map(f => (
                            <option key={f.value} value={f.value}>{f.label}</option>
                        ))}
                    </select>

                    {dataSelecionada == 14 ?
                        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                            <input
                                type="date"
                                value={dataInicial}
                                onChange={(e) => setDataInicial(e.target.value)}
                                style={dateStyle}
                            />

                            <span style={{ fontSize: 12, color: C.muted }}>até</span>

                            <input
                                type="date"
                                value={dataFinal}
                                onChange={(e) => setDataFinal(e.target.value)}
                                style={dateStyle}
                            />
                        </div>
                        : null
                    }

                    <select
                        value={funcionario}
                        onChange={e => setFuncionario(e.target.value)}
                        style={selectStyle}
                    >
                        <option value="">Todos Montadores</option>
                        {funcionariosOptions.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                    </select>

                    {!isRoleComissao &&
                        <select
                            value={filial}
                            onChange={e => setFilial(e.target.value)}
                            style={selectStyle}
                        >
                            {filiais.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                        </select>
                    }
                    <DropdownButton
                        trigger={
                            <button
                                style={{
                                    background: C.primary,
                                    color: "#fff",
                                    border: "none",
                                    padding: "6px 16px",
                                    borderRadius: 8,
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    fontSize: 12,
                                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                                    boxShadow: `0 2px 8px ${C.primary}40`,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6
                                }}
                            >
                                <i className="fa fa-download" /> Exportar
                                <i className="fa fa-caret-down" />
                            </button>
                        }
                    >
                        {(close) => (
                            <>
                                <button
                                    onClick={() => {
                                        copyElementToClipboard("relatorioEasyPallet");
                                        close();
                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-clipboard" /> Copiar P/ Transferência
                                </button>

                                <button
                                    onClick={() => {
                                        captureElementToImage("relatorioEasyPallet", "relatorio_montagem.png");
                                        close();
                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-image" /> Baixar Imagem
                                </button>

                                <button
                                    onClick={() => {
                                        const title =
                                            "Relatório de Montagem de Cargas - " +
                                            filiais.find(item => item.id === filial)?.nome || '';

                                        const subtitle =
                                            formatLocalDate(dataInicial) +
                                            " a " +
                                            formatLocalDate(dataFinal);

                                        exportDashboardToPDF(
                                            ['relatorioEasyPallet'],
                                            title,
                                            subtitle
                                        );

                                        close();
                                    }}
                                    style={dropdownItem}
                                    className="hover:bg-muted hover:text-foreground rounded-md transition-colors duration-150"
                                >
                                    <i className="fa fa-file-pdf" /> Download PDF
                                </button>
                            </>
                        )}
                    </DropdownButton>

                </div>
            </div>

            <div className="px-4 py-3" id="relatorioEasyPallet">
                <div className="animate-in grid lg:grid-cols-4 md:grid-cols-6 gap-3 mb-4 repeat(auto-fill, minmax(190px, 1fr))">
                    <KPICard
                        label="Total de Caixas"
                        value={formatNum(relatorio?.totalCaixas)}
                        color={C.c1}
                        icon="📦"
                        loading={loading}
                    />

                    <KPICard
                        label="Média de Caixas por Dia"
                        title={relatorio?.mediaCaixasPorDia?.toFixed(2)}
                        value={formatNum(relatorio?.mediaCaixasPorDia?.toFixed(0))}
                        color={C.c4}
                        icon="📊"
                        loading={loading}
                    />

                    <KPICard
                        label="Caixas por Montador (Média)"
                        title={relatorio?.mediaCaixasPorColaboradorPorDia?.toFixed(2)}
                        value={formatNum(relatorio?.mediaCaixasPorColaboradorPorDia?.toFixed(0)) || 0}
                        color={C.c3}
                        icon="👥"
                        loading={loading}
                    />

                    <KPICard
                        label="Total Erros"
                        value={relatorio?.totalErros || 0}
                        color={C.c5}
                        icon="❌"
                        loading={loading}
                    />

                    <KPICard
                        label="Total de Paletes"
                        value={formatNum(relatorio?.totalPaletes)}
                        color={C.c3}
                        icon="🧱"
                        loading={loading}
                    />

                    <KPICard
                        label="Média de Paletes por Dia"
                        title={relatorio?.mediaPaletesPorDia?.toFixed(2)}
                        value={formatNum(relatorio?.mediaPaletesPorDia?.toFixed(0))}
                        color={C.c4}
                        icon="📈"
                        loading={loading}
                    />

                    <KPICard
                        label="Paletes por Montador (Média)"
                        title={relatorio?.mediaPaletesPorColaboradorPorDia?.toFixed(2) || 0}
                        value={formatNum(relatorio?.mediaPaletesPorColaboradorPorDia?.toFixed(0)) || 0}
                        color={C.c2}
                        icon="👥"
                        loading={loading}
                    />

                    <KPICard
                        label="Tempo médio"
                        value={minutosParaHoras(relatorio?.mediaTempoColaborador || 0)}
                        color={C.purple}
                        icon="⏱️"
                        loading={loading}
                    />
                </div>
                <div className="flex flex-col gap-4 lg:grid lg:grid-cols-12 mb-4">
                    <div className="lg:col-span-8">
                        <ChartCard
                            title="Produção Mensal"
                            accent={C.c1}
                            view={'chart'}
                        >
                            <ProducaoMensal
                                service={service}
                                filial={filial}
                                funcionario={funcionario} />
                        </ChartCard>
                    </div>
                    <div className="lg:col-span-4">
                        {funcionario ?
                            <ChartCard
                                title="Porcentagem de Erros x Acertos"
                                accent={C.danger}
                                view={'chart'}
                            >
                                <ErrosVsAcertos report={relatorio} loading={loading} />
                            </ChartCard>
                            :
                            <ChartCard
                                title="Porcentagem de Erros x Acertos"
                                accent={C.danger}
                                view={'chart'}
                            >
                                <ErrosPorMontador report={relatorio} loading={loading} />
                            </ChartCard>
                        }
                    </div>
                    <div className="lg:col-span-6">
                        <ChartCard
                            title="Desempenho por Montador"
                            accent={C.accent}
                            view={'chart'}
                        >
                            <DesempenhoPorMontador report={relatorio} loading={loading} />
                        </ChartCard>
                    </div>
                    <div className="lg:col-span-6">
                        <ChartCard
                            title="Produção Diária"
                            accent={C.purple}
                            view={'chart'}
                        >
                            <ProducaoDiaria report={relatorio} loading={loading} />
                        </ChartCard>
                    </div>
                    <div className="lg:col-span-12">
                        <ChartCard
                            title={verCaixasPorDia !== "chart" ? "Produção de Caixas Por Montador" : "Produção de Paletes Por Montador"}  
                            accent={C.c2}
                            view={verCaixasPorDia}
                            onViewChange={setVerCaixasPorDia}
                            tableContent={
                             <ProducaoHeatmap report={relatorio} loading={loading} type={'totalCaixas'} ranges={[
                                { from: 0, to: 0, color: "#e9e78a", name: "Zerado" },
                                { from: 1, to: 3359, color: "#e98a8a", name: "Abaixo da Meta" },
                                { from: 3360, to: 9999, color: "#10B981", name: "Atingiu a Meta" }
                            ]} />
                            }
                        >
                                <ProducaoHeatmap report={relatorio} loading={loading} type={'totalPaletes'} ranges={[
                                    { from: 0, to: 0, color: "#e9e78a", name: "Zerado" },
                                    { from: 1, to: 19, color: "#e98a8a", name: "Abaixo da Meta" },
                                    { from: 20, to: 9999, color: "#10B981", name: "Atingiu a Meta" }
                                ]} />
                           
                        </ChartCard>
                    </div>
                </div>
                <TabelaPorMontador report={relatorio?.produtividade} />
            </div>
        </div>
    );
}
